<template>
  <button
    v-if="!href"
    class="fshr-buttonVue"
    :class="[
      color && `fshr-buttonVue--${color}${outlined ? '--outlined' : ''}`,
      size && `fshr-buttonVue--${size}`,
      shadowed && `fshr-buttonVue--shadowed`,
      disabled && `fshr-buttonVue--disabled`,
      (iconLeft || iconRight) && `fshr-buttonVue--hasIcon`,
    ]"
    :disabled="disabled"
    :type="type"
    @click="onClick"
  >
    <i v-if="iconLeft" class="fshr-buttonVue__iconLeft" :class="iconLeft" />
    <span class="fshr-buttonVue__label"><slot /></span>
    <i v-if="iconRight" class="fshr-buttonVue__iconRight" :class="iconRight" />
  </button>
  <a
    v-else
    rel="noopener"
    class="fshr-buttonVue"
    :href="href"
    :disabled="disabled"
    :class="[
      color && `fshr-buttonVue--${color}${outlined ? '--outlined' : ''}`,
      size && `fshr-buttonVue--${size}`,
      shadowed && `fshr-buttonVue--shadowed`,
      disabled && `fshr-buttonVue--disabled`,
    ]"
    v-bind="attdata"
  >
    <i v-if="iconLeft" class="fshr-buttonVue__iconLeft" :class="iconLeft" />
    <span class="fshr-buttonVue__label"><slot /></span>
    <i v-if="iconRight" class="fshr-buttonVue__iconRight" :class="iconRight" />
  </a>
</template>

<script>
const BUTTON_STYLES = [
  "primary",
  "secondary",
  "success",
  "warning",
  "danger",
  "link",
];
const BUTTON_SIZES = ["xs", "sm", "md"];
const BUTTON_TYPES = ["button", "submit"];

/**
 * Component to perform some actions such as: redirecting to other page,
 * or submit a form.
 * @emits onClick when button is clicked
 */
export default {
  name: "vue-button",
  props: {
    /**
     * define a color of the button
     */
    color: {
      type: String,
      required: false,
      default: "success",
      validator: (value) => (BUTTON_STYLES.includes(value) ? value : "success"),
    },
    /**
     * there are two types:
     * - submit (to submit form)
     * - button (with and without a link) comes in combination
     * with @param href parameter. If @param href is not exists
     * then @param onClick callback can be defined if we want to
     * handle click events on the button
     */
    type: {
      type: String,
      required: false,
      validator: (value) => (BUTTON_TYPES.includes(value) ? value : "button"),
    },
    /**
     * define a size of the button
     */
    size: {
      type: String,
      required: false,
      validator: (value) => (BUTTON_SIZES.includes(value) ? value : "md"),
    },
    /**
     * define if button is outlined
     */
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * define if button has shadow
     */
    shadowed: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * define if button is disabled
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * define icon class that will be displayed on
     * the left side of button's text
     */
    iconLeft: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * define icon class that will be displayed on
     * the right side of button's text
     */
    iconRight: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * to property defines where button should be
     * redirected if buttons behaives like <a> link
     */
    href: {
      type: String,
      required: false,
      default: null,
    },
    attdata: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },

  methods: {
    onClick(e) {
      e.preventDefault();
      e.stopPropagation();

      this.$emit("onClick");
    },
  },
};
</script>
